import { CreditCard } from 'lucide-react';
import { AdminTab } from './AdminSidebar';
import AdminPageHeader from './AdminPageHeader';

interface AdminPaymentsProps {
  setActiveTab: (tab: AdminTab) => void;
}

const AdminPayments = ({ setActiveTab }: AdminPaymentsProps) => {
  return (
    <div className="animate-in fade-in duration-500">
      <div className="mb-6">
        <AdminPageHeader 
          title="Payments"
          description="Transaction monitoring and billing lifecycle management."
        />
      </div>

      <div className="flex flex-col items-center justify-center py-32 bg-card rounded-xl border border-border shadow-sm text-center px-6">
        <div className="h-20 w-20 rounded-full bg-muted flex items-center justify-center mb-6">
          <CreditCard className="h-10 w-10 text-muted-foreground opacity-50" />
        </div>
        <h3 className="text-xl font-bold tracking-tight mb-2 text-foreground">Payment Infrastructure</h3>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          Detailed transaction monitoring and billing lifecycle management is being optimized for the new Cleopatra interface.
        </p>
        <button 
          className="mt-8 rounded-lg h-10 px-6 font-medium bg-primary text-primary-foreground hover:bg-primary/90 transition-colors shadow-sm" 
          onClick={() => setActiveTab('overview')}
        >
          Return to Overview
        </button>
      </div>
    </div>
  );
};

export default AdminPayments;
